import { GridActionsCellItem } from "@mui/x-data-grid";
import { ComponentProps } from "../types";
import { Icon } from "@mui/material";
import DashboardPageContext from "../DashboardPageContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import DataGridRowContext from "./DataGridRowContext";

function Component({ component, evaluteScript }: ComponentProps) {
	const navigate = useNavigate();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const row = useContext(DataGridRowContext);
	const doNavigation = () => {
		const path = evaluteScript(component.properties["path"]) as string;
		navigate(path);
	};
	return (
		<GridActionsCellItem
			disabled={component.properties["disabled"] ? (evaluteScript(component.properties["disabled"]) as boolean) : false}
			icon={<Icon>{component.properties["icon"]}</Icon>}
			label={component.properties["label"]}
			title={component.properties["label"]}
			onClick={() => doNavigation()}
		/>
	);
}

export default Component;
